
import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCropCyclePeriodFilter } from 'src/app/core/models/period-selector/newCropCyclePeriodFilter';
import { NewCropCyclePeriodSelectorItem } from './base/new-crop-cycle-period-selector-item';


export class CropWeekPeriodSelectorItem extends NewCropCyclePeriodSelectorItem {
    interval = NewPeriodSelectorInterval.CropWeek;
    hasNavigation = true;

    constructor(name: string) {
        super(name);
    }

    getPeriodFilter = () => {
        const periodFilter = new NewCropCyclePeriodFilter();
        periodFilter.periodInterval = NewPeriodSelectorInterval.CropWeek;
        periodFilter.intervalLength = 1;
        return periodFilter;
    }
}
